import React from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

/**
 * This Tooltip by default disables the Popper portal so the tooltip stays "inside" the
 * same scrollable container as its anchor. By default, MUI Tooltips are rendered
 * in a portal (attached to <body>), so when an anchor element inside overflowed
 * container scrolls out of view, the tooltip can remain visible on screen.
 * Using `slotProps.popper.disablePortal = true` makes the tooltip scroll/clip
 * together with its trigger element.
 */

const Tooltip: React.FC<TooltipProps> = (props) => {
  // There are two ways to specify Popper props so we need to cover both cases.
  if (props.slotProps?.popper?.disablePortal === undefined && props.PopperProps?.disablePortal === undefined) {
    props = {
      ...props,
      slotProps: {
        ...props.slotProps,
        popper: {
          ...props.slotProps?.popper,
          disablePortal: true
        }
      }
    };
  }

  return <MuiTooltip {...props} />;
};

export default Tooltip;
